import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./App";
export const ProtectedRoute = ({ children }) => {
  const { currentUser } = useContext(AuthContext);
  const location = useLocation();

  if (!currentUser) {
    // Redirect to the sign-in page, but pass the current location in state
    // so it can be redirected back after signing in
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
};
